import { Avatar, Button, Descriptions, List, Select, Steps, message } from "antd"
import Card from "../../components/Card"
import { Link, useLocation } from "react-router-dom"
import { useContext, useEffect, useRef, useState } from "react"
import { AuthService } from "../../services/AuthService"
import { ORDER_STATUS } from "../../constants"
import Invoice from "../../components/Invoice"
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { UserContext } from "../../context/userContext"
import moment from "moment"
import { PrinterOutlined } from "@ant-design/icons"

type ProductType = {
    productId: null | number,
    productName: string,
    quantity: number,
    unitPrice: number,
    productPrice: number,
    price: number,
}

export type OrderType = {
    id: number;
    userId: null | string;
    fullName: null | string;
    orderDate: null | string;
    totalAmount: null | number;
    totalDiscount: null | number;
    status: number;
    items: ProductType[];
}

const ViewOrder = () => {

    const location = useLocation();

    const invoiceRef = useRef<any>(null);

    const {user} = useContext(UserContext);

    const [messageApi, contextHolder] = message.useMessage();

    const [order, setOrder] = useState<OrderType>({
        id: null,
        userId: null,
        fullName: null,
        totalAmount: null,
        totalDiscount: null,
        orderDate: null,
        status: 0,
        items: [],
    });

    const [newStatus, setNewStatus] = useState(null);



    const getOrderDetails = async (orderId) => {
        let res = await AuthService.getOrderDetails(orderId);
        console.log("RESS", res);
        if (res) {
            setOrder(res);
            setNewStatus(res?.status)
        }
    }

    const changeOrderStatus = async () => {
        let res = await AuthService.changeOrderStatus(order?.id, { status: newStatus });

        console.log("res", res);

        if (res && res?.id) {
            messageApi.open({
                type: 'success',
                content: 'Statusi i porosise u ndryshua',
            });
            getOrderDetails(location?.state?.order?.id);
        }

    }


    const handlePrint = useReactToPrint({
        content: () => invoiceRef.current,
    });



    useEffect(() => {
        if (location.state?.order) {
            console.log("order param", location?.state?.order)
            // setUser({ ...location.state.user });
            // location.state.user = null;
            // getUserById(location?.state?.user?.id)
            getOrderDetails(location?.state?.order?.id);

        }
    }, [])


    return (
        <div className="container">
            {contextHolder}

            <div className="row">
                <div className="col-lg-8">
                    <div className="mb-4">
                        <Steps
                            progressDot
                            current={order?.status == 0 || order?.status == 1 || order?.status == 4 ? 0 : order?.status == 2 ? 1 : 2}
                            items={[
                                {
                                    title: 'Ne proces',
                                },
                                {
                                    title: 'Derguar',
                                },
                                {
                                    title: 'Pranuar',
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className="col-lg-8">

                    <Card title={`Te dhenat e porosise #${order?.id}`} HeaderButton={<><Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
      Print
    </Button></>}>


                        <Descriptions>
                            <Descriptions.Item label="Order ID">#{order?.id}</Descriptions.Item>
                            <Descriptions.Item label="Emri">{order?.fullName}</Descriptions.Item>
                            <Descriptions.Item label="Data">{moment(order?.orderDate).format('DD MMMM YYYY [ne] HH:mm')}</Descriptions.Item>
                            <Descriptions.Item label="Statusi">{ORDER_STATUS[order?.status]}</Descriptions.Item>
                            <Descriptions.Item label="Totali i shportes">
                                {order?.totalAmount}€
                            </Descriptions.Item>
                            <Descriptions.Item label="Zbritje">
                                {order?.totalDiscount ? order?.totalDiscount : 0}€
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </div>
                {user?.details?.roleName !== "User" && (
                     <div className="col-lg-4">
                
                     <Card title="Menaxho porosine">
                         <Select
                             labelInValue
                             value={newStatus ? newStatus : ORDER_STATUS[0]}
                             defaultValue={newStatus ? newStatus : ORDER_STATUS[0]}
                             style={{ width: "100%" }}
                             onChange={(e: any) => {
 
                                 // setOrder({ ...order, status: e?.value });
                                 setNewStatus(e?.value)
                                 // setProduct({ ...product, brandId: e?.value })
                             }}
                             options={ORDER_STATUS?.map((item, idx) => ({
                                 value: idx,
                                 label: item
                             }))}
                         />
                         <Button className="mt-3" loading={false} disabled={false} type="primary" onClick={changeOrderStatus}>Ndrysho statusin</Button>
                     </Card>
                 </div>
                )}
                <div className="col-lg-8 mt-3">
                    <Card title="Produktet">
                        <List

                            dataSource={order?.items}
                            renderItem={(item, index) => (
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={
                                            <Avatar style={{ backgroundColor: "orange", verticalAlign: 'middle', textTransform: "uppercase" }} size="large" >
                                                {item?.productName?.charAt(0)}
                                            </Avatar>
                                        }
                                        title={<Link to={"/articles"}>{item?.productName}</Link>}
                                        description={`${item?.quantity} x ${item?.productPrice}€`}
                                    />
                                </List.Item>
                            )}
                        />
                    </Card>
                </div>
            </div>

            {order && order.id && <Invoice order={order} ref={invoiceRef} />}
        </div>
    )
}

export default ViewOrder